import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `SignAccountOpControllerStateProvider` not mounted on RN.
export default function useSignAccountOpControllerState(): any {
  const { state } = useController('SignAccountOpController' as any)
  return state as any
}
